import { action, observable, makeObservable } from 'mobx';
import {X9Content, X9ContentSnapshot} from '../../../../domain';
import {Control} from '../../../../lib/helpers';
import {ClassroomRole} from '../../../classroom/models/classroom-models';
import {x9ClassroomHelper} from './x9-classroom-helper';
import {contentKey, scopedContentKey, X9ContentStateStore} from './X9ContentStateStore';

export class X9ContentViewStore implements X9ContentStateStore {
  readonly role = new Control<ClassroomRole>('', 'Teacher');

  @observable.shallow
  readonly state: Map<string, any> = new Map<string, any>();

  constructor(readonly x9: X9Content | X9ContentSnapshot) {
    makeObservable(this);
    this.resetState();
  }

  get<T>(key: string): T | null {
    const result = this.state.get(key);
    if (result === undefined)
      return null;
    return result;
  }

  @action
  set<T>(key: string, value: T): void {
    this.state.set(key, value);
  }

  getContentState<T>(id: number): T | null {
    return this.get<T>(contentKey(id));
  }

  @action
  setContentState<T>(id: number, state: T) {
    this.set(contentKey(id), state);
  }

  getScopedContentState<T>(id: number, scope: string | number): T | null {
    return this.get<T>(scopedContentKey(id, scope));
  }

  @action
  setScopedContentState<T>(id: number, scope: string | number, state: T): void {
    this.set(scopedContentKey(id, scope), state);
  }

  @action
  resetState = () => {
    x9ClassroomHelper.resetState(this, this.x9);
  };
}
